import React from "react";
import styles from "styles/modules/moduleSteps.module.scss";

const ModuleStepper = ({ currentStep, steps, children }) => {
  return (
    <>
      <div className={`d-flex  ${styles.aistepperContainer}`}>
        {/* <div className={styles.emptyBox}> </div> */}
        <div className="d-flex flex-row flex-wrap">
          {steps.map((label, index) => {
            const stepNumber = index + 1;
            const isCompleted = stepNumber < currentStep;
            const isActive = stepNumber === currentStep;
            const isLastStep = index === steps.length - 1;
            const isBeforeActive = stepNumber === currentStep - 1;

            // Determine border class
            let borderClass = styles.borderDefaultGen;
            if (isCompleted) {
              borderClass = isBeforeActive
                ? styles.borderActive
                : styles.borderActiveBussinessRules;
            } else if (isActive && !isLastStep) {
              borderClass = styles.borderDefaultGen;
            }

            // Determine circle state
            let circleState = styles.circleDefault;
            if (isCompleted) {
              circleState = styles.circleActive;
            } else if (isActive) {
              circleState = styles.circleCurrent;
            }

            // Determine width class
            let widthClass = styles.step01Width;
            if (index === 0) widthClass = styles.step01Width;
            if (index === steps.length - 1) widthClass = styles.step01Width;

            return (
              <div
                key={index}
                className={`${styles.genAiSteps} ${widthClass} ${borderClass}`}
              >
                <div className={`${styles.one} ${circleState}`}>
                  <span>{label}</span>
                </div>
              </div>
            );
          })}
        </div>

        <article className={styles.previewBox}>{children}</article>
      </div>
    </>
  );
};

export default ModuleStepper;
